import type { ReactNode } from "react";
import { Icon, type IconName } from "../components/Icon";
import "./OwnerPage.css";

/**
 * An owner page with nothing on it yet: one icon, one sentence, one button, and under them, when there is
 * a second way in, one quiet line. Centred, and never a picture.
 */
export function OwnerEmpty({ icon, children, action, quiet, status = false, compact = false }: {
  icon: IconName;
  /** The one sentence: what is missing and why it matters, or what comes next. */
  children: ReactNode;
  /** The one button. */
  action?: ReactNode;
  /** A line of muted text with the other way in, when there is one. */
  quiet?: ReactNode;
  /** True when the sentence is a state that will change by itself (a read under way), so it is announced. */
  status?: boolean;
  /** One part of a page that has others: it takes only the room it needs. */
  compact?: boolean;
}) {
  return <div className={`owner-empty${compact ? " is-compact" : ""}`} role={status ? "status" : undefined}>
    <span className="owner-empty-mark" aria-hidden="true"><Icon name={icon} size={24} /></span>
    <p>{children}</p>
    {action}
    {quiet ? <p className="owner-empty-quiet">{quiet}</p> : null}
  </div>;
}
